import React from 'react'
import {Table} from "antd"

const ClubMemberFindTrackBoundsDetail = ({loading, datasource}) => {
    const columns = [
        {
            title: '排名',
            dataIndex: 'ranks',
            key: 'ranks',
        },
        {
            title: '时间',
            dataIndex: 'utime',
            key: 'utime',
        },
        {
            title: '奖项',
            dataIndex: 'award_name',
            key: 'award_name',
        },
        {
            title: '期数',
            dataIndex: 'issue',
            key: 'issue',
            render: (text) => <span>第 {text} 期</span>,
        },
        {
            title: '战豆',
            dataIndex: 'bean',
            key: 'bean',
        },
        {
            title: '奖金',
            dataIndex: 'prize',
            key: 'prize',
            render: (text) => (
                <span style={{color: 'red'}}>¥ {(text / 100).toFixed(2)}元</span>
            ),
        },
        {
            title: '备注',
            dataIndex: 'note',
            key: 'note',
        },
    ]

    return (
        <div>
            <Table
                loading={loading}
                columns={columns}
                dataSource={datasource}
            />
        </div>
    )
}
export default ClubMemberFindTrackBoundsDetail


// WEBPACK FOOTER //
// ./src/containers/ClubMemberList/component/ClubMemberFind/component/ClubMemberFindTrack/component/ClubMemberFindTrackBoundsDetail.js